import React, { Component } from 'react';
import { Paper, Grid, Typography, Button, CircularProgress, IconButton, TableSortLabel, Hidden, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core';
import Moment from 'react-moment'
import { HistoricalOrder } from '../../../api/models/OrderData';
import { HistoricalOrdersProps } from '../../connected/HistoricalOrdersCnn'
import { withRouter } from 'react-router';
import LogoAndTitle from '../../../Layout/components/LogoAndTitle';
import { ExpandMore, ArrowBack } from '@material-ui/icons';
import { CSSProperties } from '@material-ui/styles';
import { getDescendantProp } from '../../../Common/CommonFunctions';
import ProductsListQuote from '../../../ProductsSearch/components/ProductList/ProductsListQuote';

type State = {
    sortField: string | null,
    sortAscending: boolean
}

const sortHeaderStyle: CSSProperties = {
    cursor: 'pointer',
    userSelect: 'none',
    WebkitUserSelect: 'none'
}

class HistoricalOrders extends Component<HistoricalOrdersProps, State> {
    constructor(props: HistoricalOrdersProps) {
        super(props)

        this.state = {
            sortField: "delivery.generated",
            sortAscending: false
        }

        this.renderOrdersWidget = this.renderOrdersWidget.bind(this)
        this.renderOrdersBrowser = this.renderOrdersBrowser.bind(this)
        this.sort = this.sort.bind(this)
    }

    componentDidMount() {
        if (!this.props.isBusy)
            this.props.getHistoricalOrders()
    }

    sort(orders: HistoricalOrder[]): HistoricalOrder[] {
        if (this.state.sortField === null)
            return orders

        let sorted: HistoricalOrder[] = orders.slice().filter(o => o.delivery !== null)
        const field: string = this.state.sortField!

        let orderModifier = this.state.sortAscending ? 1 : -1
        sorted.sort((a, b) => (getDescendantProp((a), field) > getDescendantProp((b), field) ? orderModifier * 1 : orderModifier * -1))

        return sorted
    }

    renderOrdersWidget() {
        return (
            <Paper style={{ padding: '15px' }}>
                <Grid container>
                    <Grid item sm={10}>
                        <Typography variant="h2">Your last orders</Typography>
                    </Grid>

                    <Grid item sm={2}>
                        <Button disabled={this.props.historicalOrders!.length === 0} variant="outlined" onClick={
                            () => {
                                this.props.history.push("/HistoricalOrders")
                            }
                        }>Show all</Button>
                    </Grid>
                    <Grid item sm={12}>
                        {this.props.historicalOrders!.length === 0 ?
                            <Typography variant="h3">You have no orders yet.</Typography>
                            :
                            <span>
                                {this.props.historicalOrders!.reverse().slice(0, 5).map((hs, i) => {
                                    if(hs.delivery !== null)
                                        return (
                                            <Grid key={i} container alignItems="center">
                                                <Grid item sm={3}>
                                                    <Typography variant="h3">{hs.orderSheetName}</Typography>
                                                </Grid>
                                                <Grid item sm={3}>
                                                    <Typography variant="h4"><Moment fromNow date={new Date(hs.delivery.generated + 'Z')} local={true}></Moment></Typography>
                                                </Grid>
                                                <Grid item sm={3}>
                                                    <Typography variant="h4">{hs.delivery.items.length} products</Typography>
                                                </Grid>
                                                <Grid item sm={3}>
                                                    <Typography variant="h4">AU$&nbsp;{hs.delivery.finalPrice}</Typography>
                                                </Grid>
                                            </Grid>
                                        )
                                })}
                            </span>
                        }
                    </Grid>
                </Grid>
            </Paper>
        )
    }


    renderRows(historicalOrders: HistoricalOrder[]) {
        return (
            <Grid container alignItems="center" alignContent="center">
                <Grid item xs={12} sm={12}>
                    {historicalOrders!.length === 0 ?
                        <Typography variant="h3">You have no orders yet.</Typography>
                        :
                        <span>
                            {historicalOrders!.map((hs, i) => {
                                if(hs.delivery !== null)
                                    return (
                                        <ExpansionPanel key={i}>
                                            <ExpansionPanelSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <Grid key={i} container alignItems="center">
                                                    <Grid item xs={4} sm={3}>
                                                        <Typography variant="h3">{hs.orderSheetName}</Typography>
                                                    </Grid>
                                                    <Grid item xs={4} sm={3}>
                                                        <Typography variant="h4">{hs.status}</Typography>
                                                    </Grid>
                                                    <Grid item xs={4} sm={3}>
                                                        <Typography variant="h4"><Moment format={"DD/MM/YYYY HH:mm:ss"} date={new Date(hs.delivery.generated + 'Z')} local={true}></Moment><br/><small><Moment fromNow date={new Date(hs.delivery.generated + 'Z')} local={true}></Moment></small></Typography>
                                                    </Grid>
                                                    <Hidden xsDown>
                                                        <Grid item sm={3}>
                                                            <Typography variant="h4">AU$&nbsp;{hs.delivery.finalPrice}</Typography>
                                                        </Grid>
                                                    </Hidden>
                                                </Grid>
                                            </ExpansionPanelSummary>

                                            <ExpansionPanelDetails>
                                                <Grid container alignItems="center">
                                                    <Grid item xs={12} sm={12}>
                                                        <ProductsListQuote quotedOrder={hs.delivery} missingProducts={null} />
                                                    </Grid>
                                                </Grid>
                                            </ExpansionPanelDetails>

                                        </ExpansionPanel>
                                    )
                            })}
                        </span>
                    }
                </Grid>
            </Grid>
        )
    }

    renderOrdersBrowser() {
        return (
            <div>
                <Grid container alignItems="center" alignContent="center" style={{ padding: '12px 60px 6px 24px' }}>
                    <Grid item xs={4} sm={3} style={Object.assign({}, sortHeaderStyle, { textAlign: 'left' })}>
                        <TableSortLabel
                            active={this.state.sortField === 'orderSheetName'}
                            direction={this.state.sortAscending ? 'asc' : 'desc'}
                            onClick={() => this.setState({ sortAscending: !this.state.sortAscending, sortField: 'orderSheetName' })}
                        >
                            <Typography variant="button">Order sheet</Typography>
                        </TableSortLabel>
                    </Grid>

                    <Grid item xs={4} sm={3} style={Object.assign({}, sortHeaderStyle, { textAlign: 'left' })} >
                        <TableSortLabel
                            active={this.state.sortField === 'status'}
                            direction={this.state.sortAscending ? 'asc' : 'desc'}
                            onClick={() => this.setState({ sortAscending: !this.state.sortAscending, sortField: 'status' })}
                        >
                            <Typography variant="button">Status</Typography>
                        </TableSortLabel>
                    </Grid>

                    <Grid item xs={4} sm={3} style={Object.assign({}, sortHeaderStyle, { textAlign: 'left' })} >
                        <TableSortLabel
                            active={this.state.sortField === 'delivery.generated'}
                            direction={this.state.sortAscending ? 'asc' : 'desc'}
                            onClick={() => this.setState({ sortAscending: !this.state.sortAscending, sortField: 'delivery.generated' })}
                        >
                            <Typography variant="button">When</Typography>
                        </TableSortLabel>
                    </Grid>

                    <Hidden xsDown>
                        <Grid item sm={3} style={Object.assign({}, sortHeaderStyle, { textAlign: 'left' })} >
                            <TableSortLabel
                                active={this.state.sortField === 'delivery.finalPrice'}
                                direction={this.state.sortAscending ? 'asc' : 'desc'}
                                onClick={() => this.setState({ sortAscending: !this.state.sortAscending, sortField: 'delivery.finalPrice' })}
                            >
                                <Typography variant="button">Price</Typography>
                            </TableSortLabel>
                        </Grid>
                    </Hidden>
                </Grid>

                {this.renderRows(this.sort(this.props.historicalOrders!))}

            </div>
        )
    }

    render() {
        return (
            <div>
                {this.props.historicalOrders !== null && !this.props.isBusy ?
                    <div style={{ paddingBottom: '25px' }}>
                        {this.props.mode === "widget" ?
                            <div>
                                {this.renderOrdersWidget()}
                            </div>
                            :
                            <div>
                                {this.renderOrdersBrowser()}
                            </div>
                        }
                    </div>

                    :

                    <div style={{ textAlign: 'center' }} >
                        <CircularProgress size={50} />
                    </div>
                }
            </div>
        );

    }
}

export default withRouter(HistoricalOrders);